const TikTokSvg = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.5 5.25C17.273 5.942 18.193 6.473 19.2 6.797V9.55c-1.29-.028-2.51-.34-3.585-.885v5.888c0 3.363-2.728 6.097-6.09 6.097-1.309 0-2.528-.416-3.527-1.123a6.084 6.084 0 0 1-2.563-4.975c0-3.363 2.726-6.099 6.09-6.099 .39 0 .777.036 1.158.11v3.103a2.995 2.995 0 0 0-1.158-.235c-1.66 0-3.006 1.35-3.006 3.01 0 1.66 1.346 3.008 3.006 3.008 1.66 0 3.006-1.348 3.006-3.008V2h3.109c-.005 1.188.471 2.27 1.46 3.25Z"
                fill="#000000"
            />
        </svg>
    );
};

export default TikTokSvg;

